import apiClient from './apiClient'
import { API_PATHS } from '@/constants/api'
import type {
  Conversation,
  ConversationListResponse,
  ConversationFilters,
  ConversationThreadPage,
} from '@/types/Conversation'

// One row per contact — groups every session a contact has had and keeps
// the most recent one for status/preview/filters (see chat-service's
// MessageService.findContacts).
export async function getConversations(
  filters: ConversationFilters = {},
): Promise<ConversationListResponse> {
  const { page = 1, limit = 20, sessionStatus } = filters
  const params: Record<string, string | number> = { page, limit }

  if (sessionStatus) {
    params.sessionStatus = sessionStatus
  }

  const response = await apiClient.get<ConversationListResponse>(
    API_PATHS.CONVERSATIONS.BASE,
    { params },
  )
  return response.data
}

export async function getConversationThread(
  contactPhone: string,
  before?: string,
  limit = 20,
): Promise<ConversationThreadPage> {
  const params: Record<string, string | number> = { limit }
  if (before) params.before = before

  const response = await apiClient.get<ConversationThreadPage>(
    API_PATHS.CONVERSATIONS.THREAD(contactPhone),
    { params },
  )
  return response.data
}

export async function getConversation(id: string): Promise<Conversation> {
  const response = await apiClient.get<Conversation>(
    API_PATHS.MESSAGES.BY_ID(id),
  )
  return response.data
}

export async function closeConversation(id: string): Promise<Conversation> {
  const response = await apiClient.patch<Conversation>(
    API_PATHS.MESSAGES.CLOSE(id),
  )
  return response.data
}
